import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Container, Row, Col, Modal, Spinner, Form, Button, Card } from "react-bootstrap";
import Select from 'react-select';
import empresas from 'api/empresas';
import consultaEstado from 'api/consultaEstado';
import { AccountContext } from 'components/Account/Account';
import { TIPOS_DOCUMENTO_TEXTO } from 'constants/tiposDocumento';
import { getOrigenLabel } from 'constants/origenEmision';

const ConsultaEstadoDocs = () => {

    const [empresa, setEmpresa] = useState('');
    const [empresaList, setEmpresaList] = useState([]);
    const {user,getSession} = useContext(AccountContext);
    const [folio, setFolio] = useState('');
    const [tipodocumento, setTipodocumento] = useState('39');
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(true);
    const [Message, setMessage] = useState('');
    const [descripcion, setdescripcion] = useState('');
    const [origen, setOrigen] = useState('');
    const [descripcionE, setdescripcionE] = useState('');
    const [detalle, setdetalle] = useState('');
    const [fecharecepcion, setfecharecepcion] = useState('');
    const handleClose = () =>
    {setShow(false)
    setFolio('');
    };

    const options = useMemo(() =>
      empresaList
        .filter((e) => e.rut != 1)
        .map((e) => ({ value: e.rut, label: `${e.rut} - ${e.name}` })),
      [empresaList]
    );



    const handleSelectChange = (e) =>{
      
        // console.log(e)
      
      setEmpresa(e.value)
      console.log(options)
      }

    const handleFolioChange = (e) =>{

      // console.log(e);
      // console.log(e.target);
    
      setFolio(e.target.value);
    }

    const handletipodocumentoChange = (e) =>{

      // console.log(e);
      // // console.log(e.target);
      // console.log(e.value);
    
      setTipodocumento(e.value);
    }

    


    const handleSubmit = async (e) =>{
         e.preventDefault()
        // console.log(date);
        // console.log(empresa)
        // console.log(user.idToken.jwtToken)
        if(empresa==''){
          setMessage('Por favor seleccione una empresa');
          setLoading(false);
          setShow(true);
          return;
        }

        if(folio==''){
          setMessage('Por favor escriba un número de folio');
          setLoading(false);
          setShow(true);
          return;
        }
        setLoading(true);
        setShow(true);

        // console.log(folio,empresa,tipodocumento);
        const rut = empresa;
        const params= {rut,folio,tipodocumento}
        
        const idToken= await getSession().then((session) => {return session.idToken.jwtToken});
        // console.log(params,idToken);
        try {
          const resp = await consultaEstado(params,idToken);
          setLoading(false);
          console.log(resp);
          setdetalle(resp.detalle);
          setdescripcion(resp.descripcion);
          setdescripcionE(resp.descripcionE);
          setfecharecepcion(resp.fecha_recepcion);
          setOrigen(resp.origen ?? '');
          console.log(folio);

        } catch (error) {
          setMessage('Error');
          setLoading(false);
        }
       
        
        

        //Consultar a Api por documento (folio,rutEmpresa)
    }

    useEffect(() => {
        getSession().then((session) => {
          empresas.getEmpresas(session.idToken.jwtToken).then((response) => {
                setEmpresaList(response.data)
              }).catch((error) => {
                console.log(error)
              })
        });
      }, []);

  const estadoVariant = (desc) => {
    if (!desc) return 'info';
    const text = desc.toString().toLowerCase();
    // "Tipo de documento no soportado" no es un problema del documento sino de
    // la consulta, asi que va como advertencia y no como error.
    if (text.includes('no soportado')) return 'warning';
    // Estados negativos primero: "no recibido" contiene "recibido", asi que
    // debe evaluarse antes que el caso de exito para no pintarse de verde.
    if (text.includes('no recib') || text.includes('no recep') || text.includes('no autoriz') || text.includes('rechaz') || text.includes('error') || text.includes('anulad')) return 'danger';
    if (text.includes('pendi') || text.includes('reparo') || text.includes('observ')) return 'warning';
    if (text.includes('aceptado') || text.includes('recibido') || text.includes('ok')) return 'success';
    return 'info';
  };

  return (
    <>
      <Container fluid className="page-container">
        <div className="page-header">
          <div>
            <h2 className="page-title">Estado Documento</h2>
            <p className="page-subtitle">Consulta el estado actual de un documento por folio.</p>
          </div>
        </div>

        <Card className="data-card">
          <Card.Body>
            <Form onSubmit={handleSubmit} className="filter-form">
              <Row>
                <Col xs={12} md={6} lg={4}>
                  <Form.Group className="form-field">
                    <Form.Label>Empresa</Form.Label>
                    <Select
                      options={options}
                      onChange={handleSelectChange}
                      placeholder="Selecciona una empresa..."
                      classNamePrefix="rs"
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6} lg={2}>
                  <Form.Group className="form-field">
                    <Form.Label>Folio</Form.Label>
                    <Form.Control
                      type="text"
                      value={folio}
                      onChange={handleFolioChange}
                      placeholder="N° de folio"
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6} lg={4}>
                  <Form.Group className="form-field">
                    <Form.Label>Tipo de documento</Form.Label>
                    <Select
                      options={TIPOS_DOCUMENTO_TEXTO}
                      defaultValue={TIPOS_DOCUMENTO_TEXTO.find((t) => t.value === '39')}
                      onChange={handletipodocumentoChange}
                      classNamePrefix="rs"
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} lg={2} className="d-flex align-items-end form-actions">
                  <Button type="submit" className="btn-primary-action">
                    <i className="nc-icon nc-zoom-split" />
                    Consultar
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>
      </Container>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Resultado de consulta</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="result-loading">
              <Spinner animation="border" role="status" />
              <span>Consultando documento...</span>
            </div>
          ) : Message ? (
            <div className="result-error">{Message}</div>
          ) : (
            <div className="result-grid">
              <div className="result-grid__header">
                <span className="result-grid__folio-label">Folio</span>
                <span className="result-grid__folio-value">{folio}</span>
                {descripcion && (
                  <span className={`status-badge status-badge--${estadoVariant(descripcion)}`}>
                    {descripcion}
                  </span>
                )}
                {origen && (
                  <span className={`origen-chip origen-chip--${origen}`}>
                    {getOrigenLabel(origen)}
                  </span>
                )}
              </div>
              {descripcionE && (
                <div className="result-grid__row">
                  <span className="result-grid__label">Descripción</span>
                  <span className="result-grid__value">{descripcionE}</span>
                </div>
              )}
              {detalle && (
                <div className="result-grid__row">
                  <span className="result-grid__label">Detalle</span>
                  <span className="result-grid__value">{detalle}</span>
                </div>
              )}
              {fecharecepcion && (
                <div className="result-grid__row">
                  <span className="result-grid__label">Fecha recepción</span>
                  <span className="result-grid__value">{fecharecepcion}</span>
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default ConsultaEstadoDocs;
